import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { findCar } from '../rcaSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Badge from 'react-bootstrap/Badge';
import RCANextSteps from './RCANextSteps';
import RCAIssueNotice from '../info/RCAIssueNotice';
import ErrorMessage from '../../elements/ErrorMessage';
import styles from '../../styles/elements/Form.module.scss';
import rcastyles from '../../styles/rca/RCASearch.module.scss';
import { registrationOptions, initValidStateValue } from './searchOptions';
import { RadioField } from '../../utils/validation/compare/SearchValidators';
import { AutoVINField } from '../../utils/validation/compare/RCAValidators';
import { FormChecker } from '../../utils/validation/FormValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCar } from '@fortawesome/free-solid-svg-icons';

var RCACarStart = function RCACarStart(props) {
  var vehiclesNumber = props.vehiclesNumber,
      CSRFToken = props.CSRFToken,
      editStep = props.editStep,
      activeVehicle = props.activeVehicle,
      editActiveVehicle = props.editActiveVehicle,
      addNewCar = props.addNewCar;
  var isMounted = useRef(null);
  var router = useRouter();
  var dispatch = useDispatch();
  var initValidState = {
    tip_inmatriculare: initValidStateValue,
    serie_sasiu: initValidStateValue
  };

  var _useState = useState(initValidState),
      isValid = _useState[0],
      editIsValid = _useState[1];

  var _useState2 = useState(registrationOptions[0]),
      tip_inmatriculare = _useState2[0],
      editTip_inmatriculare = _useState2[1];

  var _useState3 = useState(''),
      serie_sasiu = _useState3[0],
      editSerie_sasiu = _useState3[1];

  var _useState4 = useState(false),
      isLoading = _useState4[0],
      editIsLoading = _useState4[1];

  var _useState5 = useState(false),
      isError = _useState5[0],
      editIsError = _useState5[1];

  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var findVehicle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resultAction, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(findCar({
                CSRFToken: CSRFToken,
                vin: serie_sasiu
              }));

            case 2:
              resultAction = _context.sent;
              data = unwrapResult(resultAction);

              if (data.status == 'error') {
                editIsValid(_objectSpread(_objectSpread({}, isValid), {}, {
                  serie_sasiu: {
                    help: 'invalid-feedback',
                    field: 'is-invalid',
                    error: data.message
                  }
                }));
              } else if (data.status == '400') {
                editIsError('Sesiune expirată. Pagina se va reîncarca automat.');
                setTimeout(router.reload(window.location.pathname), 1000);
              } else if (data.status == 'not found' || data.status == 'ok') {
                addNewCar({
                  serie_sasiu: serie_sasiu,
                  active: true,
                  car: {
                    tip_inmatriculare: tip_inmatriculare,
                    serie_sasiu: serie_sasiu
                  },
                  step: 'auto'
                });
              } else {
                editIsError('Te rugăm să încerci mai târziu.');
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function findVehicle() {
      return _ref.apply(this, arguments);
    };
  }();

  var saveCar = function saveCar() {
    var vehicle = {
      serie_sasiu: serie_sasiu,
      car: {
        tip_inmatriculare: tip_inmatriculare,
        serie_sasiu: serie_sasiu
      }
    };
    editActiveVehicle(vehicle);
  };

  var validationRules = {
    serie_sasiu: AutoVINField,
    tip_inmatriculare: {
      rule: RadioField,
      param: {
        field: 'tip_inmatriculare'
      }
    }
  };
  var nextSteps = ['Proprietar', 'Adresa', 'Conducatori auto']; //blur validation

  var validateFieldOnBlur = function validateFieldOnBlur(e) {
    var value = e.target.value;

    if (e.target.type == 'checkbox') {
      value = e.target.checked;
    }

    var id = e.target.id;
    var res;

    if (validationRules[id]) {
      if (typeof validationRules[id] == 'object') {
        res = validationRules[id].rule(value, validationRules[id].param);
      } else {
        res = validationRules[id](value);
      }

      editIsValid(_objectSpread(_objectSpread({}, isValid), {}, _defineProperty({}, id, {
        help: res.status ? 'valid-feeback' : 'invalid-feedback',
        field: res.status ? 'is-valid' : 'is-invalid',
        error: res.msg
      })));
    }
  };

  var handleEditField = function handleEditField(e) {
    switch (e.target.name) {
      case 'tip_inmatriculare':
        var opt = registrationOptions.find(function (item) {
          return item.value == e.target.value;
        });

        if (opt) {
          editTip_inmatriculare(opt);
        }

        break;

      case 'serie_sasiu':
        editSerie_sasiu(e.target.value.toUpperCase());
        break;
    }
  };

  var backToAutoList = function backToAutoList() {
    editStep('list');
  };

  var chooseAuto = vehiclesNumber > 0 && __jsx(Button, {
    variant: "link",
    className: "green",
    onClick: backToAutoList
  }, __jsx(FontAwesomeIcon, {
    icon: faCar,
    className: "mr-2 ",
    height: "16",
    width: "16"
  }), "List\u0103 Auto", __jsx(Badge, {
    className: "ml-2",
    pill: true,
    variant: "primary"
  }, vehiclesNumber));

  var inmatriculareField = __jsx(Col, {
    xs: 12,
    className: "".concat(styles.radio, " ")
  }, __jsx(Row, {
    className: "pb-3 align-items-center"
  }, __jsx(Form.Label, {
    column: true,
    xs: 12
  }, "Stare \xEEnmatriculare"), registrationOptions.map(function (opt, i) {
    return __jsx(Col, {
      sm: 6,
      key: i
    }, __jsx(Form.Check, {
      custom: true,
      name: "tip_inmatriculare",
      id: "tip_inamtriculare".concat(i),
      type: "radio",
      value: opt.value,
      onChange: handleEditField,
      onClick: validateFieldOnBlur,
      checked: tip_inmatriculare.value == opt.value ? true : false,
      label: opt.label,
      className: "".concat(isValid.tip_inmatriculare.field)
    }));
  }), __jsx(Form.Text, {
    className: "d-block pl-3 mt-0 helper ".concat(isValid.tip_inmatriculare.help),
    as: "div"
  }, isValid.tip_inmatriculare.error)));

  var VINField = __jsx(Col, {
    xs: 12,
    md: 6
  }, __jsx(Form.Group, null, __jsx(Form.Label, {
    htmlFor: "serie_sasiu"
  }, "Serie \u0219asiu"), __jsx(Form.Control, {
    name: "serie_sasiu",
    id: "serie_sasiu",
    value: serie_sasiu,
    onChange: handleEditField,
    onBlur: validateFieldOnBlur,
    className: isValid.serie_sasiu.field,
    placeholder: "pozi\u021Bie talon: E"
  }), __jsx(Form.Text, {
    className: "helper ".concat(isValid.serie_sasiu.help),
    as: "div"
  }, isValid.serie_sasiu.error)));

  var buttonField = __jsx(Col, {
    xs: 12,
    md: 6
  }, __jsx(Button, {
    className: "w-100",
    variant: "primary",
    type: "submit",
    disabled: isLoading ? true : false
  }, isLoading ? __jsx("div", {
    className: "d-flex align-items-center"
  }, __jsx(Spinner, {
    animation: "border",
    className: "mr-2"
  }), " Te rug\u0103m s\u0103 a\u0219tep\u021Bi") : __jsx(React.Fragment, null, "Start", __jsx(FontAwesomeIcon, {
    icon: faChevronRight,
    height: "16",
    width: "16",
    className: "ml-2"
  }))));

  var sendForm = function sendForm(e) {
    e.preventDefault();
    e.preventDefault();
    editIsLoading(true);
    editIsError(false);
    var validForm = FormChecker('rcaFrm', validationRules);

    if (validForm.status) {
      saveCar();
      findVehicle();
    } else {
      editIsValid(validForm.data);
      editIsLoading(false);
    }
  };

  var registrationInfo = tip_inmatriculare.value == 'in vederea inmatricularii' && __jsx(RCAIssueNotice, null);

  return __jsx(React.Fragment, null, __jsx("section", {
    className: "".concat(rcastyles.boxWrapper, " p-3 mb-3")
  }, __jsx("div", {
    className: "d-flex justify-content-between mb-3"
  }, __jsx("h2", {
    className: "heading2"
  }, "Autovehicul"), chooseAuto), __jsx(Form, {
    id: "rcaFrm",
    className: "".concat(styles.root, " ").concat(rcastyles.formField),
    onSubmit: sendForm
  }, __jsx(Form.Row, null, inmatriculareField), registrationInfo, __jsx(Form.Row, null, VINField), __jsx(Form.Row, null, buttonField), isError && __jsx(Form.Row, null, __jsx(Col, {
    xs: 12,
    className: "mt-3"
  }, __jsx(ErrorMessage, {
    title: "Eroare",
    message: isError
  }))))));
};

export default RCACarStart;